import { createContext } from 'react';

const SelectedModelIdContext = createContext<number>(null as unknown as number);

export default SelectedModelIdContext;
